import { Control } from 'react-hook-form';
import { FC } from 'react';
import api from 'lib/trpcClient';
import { investee as Investee } from 'further-ui/validations';
import SelectionWithRadio from '../SelectionWithRadio';

type ShareClassSelectionProps = {
  isNewShareClass: boolean;
  control: Control<
    Investee.NewCompanyFormValues | Investee.NewShareClassFormValues
  >;
  resetShareClassDropdown: () => void;
  onShareClassChange: (id: string) => void;
  investeeId: string;
};

const ShareClassSelection: FC<ShareClassSelectionProps> = ({
  isNewShareClass,
  control,
  resetShareClassDropdown,
  onShareClassChange,
  investeeId,
}) => {
  const { data: shareClasses } = api.investee.listShareClasses.useQuery(
    {
      investeeId,
    },
    {
      enabled: !!investeeId,
      staleTime: 0,
      refetchOnWindowFocus: true,
    },
  );

  return (
    <SelectionWithRadio
      control={control}
      isNewFieldName="isNewShareClass"
      selectionFieldName="shareClassId"
      existingLabel="Select existing share class"
      newLabel="Create new share class"
      newHelperText="Select if the share class is not yet in the system"
      selectBoxProps={{
        data: shareClasses?.result || [],
        placeholder: 'Select existing share class',
        valueKey: 'investeeId',
        labelKey: 'shareClass',
        disabled: isNewShareClass,
      }}
      onSelectionChange={onShareClassChange}
      onNewSelection={() => {
        resetShareClassDropdown();
        onShareClassChange('');
      }}
    />
  );
};

export default ShareClassSelection;
